import { PaginationState } from "@tanstack/react-table";
import BreadCrumb from "Common/BreadCrumb";
import TableContainer from "Common/TableContainer";
import callApi from "Common/utils/apiCaller";
import { getImageUrl } from "Common/utils/ImageDomain";
import {
  Download,
  Plus,
  Search,
  SlidersHorizontal,
  X,
  Rows4,
  GridIcon,
} from "lucide-react";
import moment from "moment";
import { showNotification } from "Common/utils/Notification";
import PaginationContainer from "./PaginationContainer";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
  useRef,
} from "react";
import Select from "react-select";
import { Pencil, Trash2 } from "lucide-react";
import Drawer from "Common/Components/Drawer";
import _ from "lodash";
import DeleteModal from "Common/DeleteModal";
import Modal from "Common/Components/Modal";
import { TailSpin } from "react-loader-spinner";
import * as Yup from "yup";
import { useFormik } from "formik";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import Dropzone from "react-dropzone";
import { UploadCloud } from "lucide-react";
import Papa from "papaparse";
import axios from "axios";
import audio from "../../images/Speaker_Icon.svg";
import video from "../../images/video.svg";
import document_pdf from "../../images/PDF_file_icon.svg";
import { createSelector } from "reselect";
import { imageUploader } from "Common/utils/imageUploader";
import { useSelector, useDispatch } from "react-redux";
import PermissionSwitch from "../../Common/Components/PermissionLocks/PermissionSwitch";
import FileNameEdit from "./FileNameEdit";
import ThumbnailEdit from "./ThumbnailEdit";
import CustomInput from "Common/Components/InputFields/CustomInput";
import { Link } from "react-router-dom";

const MediaList = () => {

  const [mediaData, setMediaData] = useState([]);
  const [read, setRead] = useState([]);
  const [showModel, setShowModel] = useState(false);
  const defaultToggle = () => setShowModel(!showModel);
  const [eventTags, setEventTags] = useState<any>([]);
  const [option, setOption] = useState<any>([]);
  const [loader, setLoader] = useState<any>(false);
  const [addTags, setAddTags] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<any>(false);
  const [selectedFile, setSelectedFile] = useState<any>();
  const [search, setSearch] = useState<any>();
  const [showTable, setShowTable] = useState<any>(true);
  const [mediaType, setMediaType] = useState<any>();
  const [medias, setMedias] = useState<any>();
  const [imageLink, setImageLink] = useState<any>();
  const [fileContent, setFileContent] = useState<any[]>([]);
  const [pageCount, setPageCount] = useState(0);
  const [eventData, setEventData] = useState<any>();
  const [show, setShow] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [totalItems, setTotalItems] = useState(0);
  const [render, setRender] = useState(false);
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: 30,
  });
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const deleteToggle = () => setDeleteModal(!deleteModal);

  const [isEditFileNameEdit, setIsEditFileNameEdit] = useState<boolean>(false);
  const [fileNameEdit, setFileNameEdit] = useState<any>();

  const [isEditThumbnailEdit, setIsEditThumbnailEdit] =
    useState<boolean>(false);
  const [thumbnailEdit, setThumbnailEdit] = useState<any>();

  const activeStyle =
    "bg-custom-700 border-custom-700 hover:bg-custom-800 hover:border-custom-800";
  const inactiveStyle =
    "bg-custom-400 border-custom-400 hover:bg-custom-600 hover:border-custom-600";

  const selectProperties = createSelector(
    (state: any) => state.Login,
    (profile) => ({
      user: profile.user,
      error: profile.error,
      success: profile.success,
      permission: profile.permission,
    })
  );

  const { error, success, user, permission } = useSelector(selectProperties);

  interface PermissionInfo {
    permissions: string[];
  }

  const rawPermission = localStorage.getItem("permission");

  const premissionInfo: PermissionInfo | null = rawPermission
    ? JSON.parse(rawPermission)
    : null;

  const audioRef = useRef(null);

  const playAudio = () => {
    audioRef.current.play();
  };

  const pauseAudio = () => {
    audioRef.current.pause();
  };
  // Pagination

  const [page, setPage] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: 30,
  });

  //fetch media
  const debouncedHandler = useCallback(
    _.debounce(
      (
        mediaType: any,

        search: any,
        pagination: any,
        render: any
      ) => {
        return fetchDateWithFilters(
          mediaType,

          search,
          pagination,
          render
        );
      },
      700
    ),
    []
  );
  async function fetchDateWithFilters(
    mediaType: any,

    search: any,
    pagination: any,
    render: any
  ) {
    let filters: { [index: string]: any } = {};
    if (mediaType) {
      filters.media_type = mediaType;
    }

    if (search) {
      filters.qtext = search;
    }
    const localData = await callApi("v1/media/list", "post", {
      pageNum: pagination?.pageIndex + 1,
      pageSize: pagination?.pageSize,
      filters,
    });

    if (localData?.status === "Success") {
      setMediaData(localData?.data?.mediaList);
      setPageCount(
        Math.ceil(localData?.data?.mediaCount / pagination?.pageSize)
      );
      setTotalItems(localData?.data?.mediaCount);
    }
  }

  const filterSearchData = (e: any) => {
    const search = e.target.value;
    setSearch(search);
  };

  const options = [
    { value: "Select...", label: "Select Media Type" },
    { value: "video", label: "Video" },
    { value: "image", label: "Image" },
    { value: "audio", label: "Audio" },
    { value: "document", label: "Document" },
  ];

  const handleChange = (selectedOption: any) => {
    if (selectedOption.value === "Select...") {
      setMediaType("");
    } else {
      setMediaType(selectedOption.value);
    }
  };
  const handleMediaChange = (selectedOption: any) => {
    if (selectedOption.value === "Select...") {
      setMedias("");
    } else {
      setMedias(selectedOption.value);
    }
  };

  useEffect(() => {
    debouncedHandler(mediaType, search, pagination, render);
  }, [mediaType, search, pagination, render]);
  // Delete Data
  const onClickDelete = (cell: any) => {
    setDeleteModal(true);
    if (cell._id) {
      setEventData(cell);
    }
  };
  useEffect(() => {
    fetchData("tags");
  }, []);

  const fetchData = async (code) => {
    try {
      const res = await callApi(`v1/content/code/${code}`, "get", {});
      if (res.status === "Success") {
        setOption(res.data.content.params);
      }
    } catch (e) {
      showNotification("Error occured", "error");
    }
  };

  const handleTagChange = (event: any) => {
    let arr = [];
    let update = [];
    for (let item of event) {
      arr.push(item.value);
      update.push({label:item.label, value:item.value})
    }
    setEventTags(arr)
    setAddTags(update);
    setMedias("tags");
    console.log("mmm", event)
  };

  const handleDelete = async () => {
    if (eventData) {
      //dispatch(onDeleteEmployee(eventData.id));

      const res = await callApi(`v1/media/${eventData?._id}/update`, "post", {
        media: { is_deleted: true },
      });
      if (res && res?.status === "Success") {
        setDeleteModal(false);
        setRender(!render);
        toast("Deleted successfully");
      }
    }
  };

  // Update Data
  const handleUpdateDataClick = (ele: any) => {
    setEventData({ ...ele });
    // if (ele.media_type === "audio") {
    //   setMedias({ label: "Audio", value: ele.media_type });
    // } else if (ele.media_type === "vedio") {
    //   setMedias({ label: "Vedio", value: ele.media_type });
    // } else if (ele.media_type === "image") {
    //   setMedias({ label: "Image", value: ele.media_type });
    // }
    // setSelectedFile({
    //   preview: ele.media_url,
    //   type: ele?.media_type,
    //   name: ele?.content_type,
    // });
    setLoader(false);
    setIsEdit(true);
    setShow(true);
  };

  const handleMedia = async (data: any) => {
    if (isEdit) {
      // if (eventTags?.length === 0) {
      //   showNotification("Please add tags");

      //   return;
      // }
      setLoader(true);
      const res = await callApi(`v1/media/${eventData?._id}/update`, "post", {
        media: {
          tags: eventTags?.length > 0 ? eventTags : [],
          extra_text: eventData?.extra_text ? eventData?.extra_text : "",
        },
      });
      setLoader(false);
      if (res?.status === "Success") {
        showNotification("Media Updated", "success");
        setMedias("");
        setRender(!render);
      } else {
        showNotification("something went wrong", "error");
      }
    } else {
      if (!selectedFile && !selectedFile?.name) {
        showNotification("please upload file");
        return;
      }
      setLoader(true);
      const ress = await imageUploader(selectedFile, user);
      setLoader(false);
      if (ress?.status === "Success") {
        showNotification("Media Uploaded", "success");
        setRender(!render);
      } else {
        showNotification("something went wrong", "error");
      }
    }
    toggle();
  };

  const handleFileNameChange = (e: any) => {
    setFileNameEdit({ ...fileNameEdit, file_name: e.target.value });
  };

  // validation
  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      media_type: medias || "",
      tags: "",
    },
    validationSchema: Yup.object().shape({
      media_type: Yup.string().required("Media File is required."),
      tags: Yup.string().optional(),
    }),
    onSubmit: (values) => {
      console.log(values, "values");
      handleMedia(values);
    },
  });

  const toggle = useCallback(() => {
    if (show) {
      setShow(false);
      setEventData("");
      setMedias("");
      setAddTags([]);
      setIsEdit(false);
      setSelectedFile("");
      setLoader(false);
    } else {
      setShow(true);
      setMedias("");
      setAddTags([]);
      setSelectedFile("");
      setEventData("");
      validation.resetForm();
    }
  }, [show, validation]);

  const handleAcceptedFiles = async (file: any) => {
    console.log(file, "file");
    if (medias !== "document") {
      if (file?.type?.split("/")[0] === medias) {
        setIsLoading(true);
        Object.assign(file, {
          preview: URL.createObjectURL(file),
          formattedSize: formatBytes(file.size),
        });
        setSelectedFile(file);
        setIsLoading(false);
      } else {
        toast("Please check media type");
      }
    } else {
      if (file?.type?.split("/")[1] === "pdf") {
        setIsLoading(true);
        Object.assign(file, {
          preview: URL.createObjectURL(file),
          formattedSize: formatBytes(file.size),
        });
        setSelectedFile(file);
        setIsLoading(false);
      } else {
        toast("Please check media type");
      }
    }
  };

  const handleAcceptedFilesThumbnail = async (file: any) => {
    if (file?.type?.split("/")[0] === "image") {
      setIsLoading(true);
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      });
      setSelectedFile(file);
      setIsLoading(false);
    } else {
      toast("Please check media type");
    }
  };

  const saveThumbnail = async () => {
    setLoader(true);
    const ress = await imageUploader(selectedFile, user);
    setLoader(false);

    if (ress?.status === "Success") {
      let res = await callApi(`v1/media/${thumbnailEdit?._id}/update`, "post", {
        media: {
          thumbnail_url: ress.data.media.media_url,
        },
      });
      if (res?.status === "Success") {
        showNotification("Media Uploaded", "success");
        setRender(!render);
      } else {
        showNotification("something went wrong", "error");
      }
    }
  };

  const formatBytes = (bytes: any, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  const saveFileName = async (id: any, value: any) => {
    console.log(id, value);
    const res = await callApi(`v1/media/${id}/update`, "post", {
      media: {
        file_name: value,
      },
    });
    if (res.status === "Success") {
      setFileNameEdit({ ...fileNameEdit, [id]: value });
      toast("File name updated");
      debouncedHandler(mediaType, search, pagination, render);
    }
  };

  const saveDetails = async () => {
    let res = await callApi(`v1/media/${fileNameEdit?._id}/update`, "post", {
      media: {
        file_name: fileNameEdit?.file_name,
      },
    });
    if (res.status === "Success") {
      toast("File name updated");
      setRender(!render);
    }
  };

  const mediaListColumns = useMemo(
    () => [
      {
        header: "File Name",
        accessorKey: "file_name",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell) => (
          <div className="flex items-center gap-2">
            {cell.row.original.file_name}
            <PermissionSwitch
              hasPermissions={premissionInfo?.permissions ?? []}
              shouldHavePermissions={["media:edit"]}
              yes={
                <Link
                  to="#!"
                  data-modal-target="addEmployeeModal"
                  className="flex items-center justify-center transition-all duration-200 ease-linear rounded-md size-8 edit-item-btn bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
                  onClick={() => {
                    const data = cell.row.original;
                    setIsEditFileNameEdit(true);
                    setFileNameEdit(data);
                  }}
                >
                  <Pencil className="size-4" />
                </Link>
              }
              no={<span></span>}
            />
          </div>
        ),
      },
      {
        header: "Media Type",
        accessorKey: "media_type",
        enableColumnFilter: false,
        enableSorting: false,
        // cell: (cell) => (
        //   <>{moment(cell.getValue()).format("DD MMM YY HH:mm")}</>
        // ),
      },
      {
        header: "Tags",
        accessorKey: "tags",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell) => (
          <>
            {cell.row.original?.tags?.slice(0, 5)?.map((item) => (
              <span>
                {cell.row.original?.tags.length === 1 ? item : `${item},`}
              </span>
            ))}

            {cell.row.original?.tags?.length > 5 ? (
              <span
                style={{
                  color: "#fb801d",
                }}
                onClick={() => {
                  setRead(cell.row.original.tags);
                  defaultToggle();
                }}
              >
                {"..."}more
              </span>
            ) : null}
          </>
        ),
      },
      {
        header: "Uploaded At",
        accessorKey: "created_at",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell) => (
          <>{moment(cell.getValue()).format("DD MMM YY HH:mm a")}</>
        ),
      },
      {
        header: "Uploaded By",
        accessorKey: "created_by",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell) => <>{cell.row.original.customer_id?.contact_name}</>,
      },
      {
        header: "Media Url",
        // accessorKey: "media_url",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell: any) => {
          return (
            <div>
              {cell.row.original.media_url !== "" ? (
                <div className="flex items-center gap-2">
                  <Link
                    to={getImageUrl(cell.row.original.media_url)}
                    className="flex items-center gap-3 pl-4"
                    target="_blank"
                  >
                    <div className="rounded-full size-6 shrink-0 bg-slate-100">
                      {cell.row.original.media_type === "image" ? (
                        <img
                          src={getImageUrl(cell.row.original.media_url)}
                          alt="img"
                          className="size-6"
                        />
                      ) : cell.row.original.media_type === "video" ? (
                        <img
                          src={video}
                          alt="Video file"
                          className="size-6 rounded-[24px] cursor-pointer"
                        />
                      ) : cell.row.original.media_type === "document" ? (
                        <img
                          src={document_pdf}
                          alt="document file"
                          className="size-6 rounded-[24px] cursor-pointer"
                        />
                      ) : (
                        <img
                          src={audio}
                          alt="Audio file"
                          className="size-6 rounded-[24px] cursor-pointer"
                        />
                      )}
                    </div>
                  </Link>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      navigator.clipboard.writeText(getImageUrl(cell.row.original.media_url));
                      toast.success("Link copied to clipboard");
                    }}
                    className="p-1 rounded-md hover:bg-slate-100"
                    title="Copy link"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <rect width="14" height="14" x="8" y="8" rx="2" ry="2"/>
                      <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/>
                    </svg>
                  </button>
                </div>
              ) : (
                <div className="flex items-center gap-3">
                  {" "}
                  <div className="rounded-full size-6 shrink-0 bg-slate-100"></div>
                </div>
              )}
            </div>
          );
        },
      },
      {
        header: "Thumbnail Url",
        // accessorKey: "media_url",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell: any) => {
          return (
            <div className="flex items-center gap-2">
              {cell.row.original.thumbnail_url &&
              cell.row.original.thumbnail_url !== "" ? (
                <Link
                  to={getImageUrl(cell.row.original.thumbnail_url)}
                  className="flex items-center gap-3 pl-4"
                  target="_blank"
                >
                  <div className="rounded-full size-6 shrink-0 bg-slate-100">
                    <img
                      src={getImageUrl(cell.row.original.thumbnail_url)}
                      alt="img"
                      className="size-6"
                    />
                  </div>
                </Link>
              ) : null}
              {cell.row.original.media_type === "video" ? (
                <PermissionSwitch
                  hasPermissions={premissionInfo?.permissions ?? []}
                  shouldHavePermissions={["media:edit"]}
                  yes={
                    <Link
                      to="#!"
                      data-modal-target="addEmployeeModal"
                      className="flex items-center justify-center transition-all duration-200 ease-linear rounded-md size-8 edit-item-btn bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
                      onClick={() => {
                        const data = cell.row.original;
                        setIsEditThumbnailEdit(true);
                        setThumbnailEdit(data);
                      }}
                    >
                      <Pencil className="size-4" />
                    </Link>
                  }
                  no={<span></span>}
                />
              ) : null}
            </div>
          );
        },
      },
      {
        header: "Content Type",
        accessorKey: "content_type", //content_type
        enableColumnFilter: false,
        enableSorting: false,
      },
      // {
      //   header: "Ref Name",
      //   accessorKey: "ref_name",
      //   enableColumnFilter: false,
      //   enableSorting: false,
      // },

      {
        header: "Action",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell: any) => (
          <div className="flex gap-3">
            <PermissionSwitch
              hasPermissions={premissionInfo?.permissions ?? []}
              shouldHavePermissions={["media:edit"]}
              yes={
                <Link
                  to="#!"
                  data-modal-target="addEmployeeModal"
                  className="flex items-center justify-center transition-all duration-200 ease-linear rounded-md size-8 edit-item-btn bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
                  onClick={() => {
                    const data = cell.row.original;
                    handleUpdateDataClick(data);
                    let update = [];
                    for (const element of data?.tags) {
                     update.push({label:element, value:element}) 
                      
                    }
                    setAddTags(update);
                  }}
                >
                  <Pencil className="size-4" />
                </Link>
              }
              no={<span></span>}
            />
            <PermissionSwitch
              hasPermissions={premissionInfo?.permissions ?? []}
              shouldHavePermissions={["media:delete"]}
              yes={
                <Link
                  to="#!"
                  className="flex items-center justify-center transition-all duration-200 ease-linear rounded-md size-8 remove-item-btn bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
                  onClick={() => {
                    const data = cell.row.original;
                    onClickDelete(data);
                  }}
                >
                  <Trash2 className="size-4" />
                </Link>
              }
              no={<span></span>}
            />
          </div>
        ),
      },
    ],
    [audio]
  );

  return (
    <React.Fragment>
      <BreadCrumb title="Media List" pageTitle="Media List" version="" />
      <DeleteModal
        show={deleteModal}
        onHide={deleteToggle}
        onDelete={handleDelete}
      />
      <ToastContainer closeButton={false} limit={1} />
      {!show && (
        <div className="grid grid-cols-12 gap-x-5">
          <div className="col-span-12 card 2xl:col-span-12">
            <div className="card-body">
              <div className="flex items-center">
                <h6 className="text-15 grow">Media List</h6>
                <div className="shrink-0">
                  <PermissionSwitch
                    hasPermissions={premissionInfo?.permissions ?? []}
                    shouldHavePermissions={["media:create"]}
                    yes={
                      <button
                        type="button"
                        className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                        onClick={toggle}
                      >
                        <Plus className="inline-block size-4" />{" "}
                        <span className="align-middle">Add Media</span>
                      </button>
                    }
                    no={
                      <button
                        type="button"
                        disabled={true}
                        className="text-grey btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                        onClick={null}
                      >
                        <Plus className="inline-block size-4" />{" "}
                        <span className="align-middle">Add Media</span>
                      </button>
                    }
                  />
                </div>
              </div>
            </div>
            <div className="!py-3.5 card-body border-y border-dashed border-slate-200 dark:border-zink-500">
              <form action="#!">
                <div className="grid grid-cols-1 gap-5 xl:grid-cols-12">
                  <div className="relative flex justify-around xl:col-span-3">
                    <span
                      style={{
                        cursor: "pointer",
                        marginRight: "3px",
                      }}
                      className={`text-white btn ${
                        showTable ? activeStyle : inactiveStyle
                      } focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20`}
                      onClick={() => setShowTable(true)}
                    >
                      <span
                        style={{
                          display: "flex",
                          whiteSpace: "nowrap",
                          alignItems: "center",
                        }}
                      >
                        <Rows4 style={{ paddingRight: "5px" }} />
                        Table View
                      </span>
                    </span>

                    <span
                      style={{ cursor: "pointer" }}
                      className={`text-white btn ${
                        !showTable ? activeStyle : inactiveStyle
                      } focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20`}
                      onClick={() => setShowTable(false)}
                    >
                      <span
                        style={{
                          display: "flex",
                          whiteSpace: "nowrap",
                          alignItems: "center",
                        }}
                      >
                        <GridIcon style={{ paddingRight: "5px" }} />
                        Grid View
                      </span>
                    </span>
                  </div>

                  <div className="relative xl:col-span-2">
                    <input
                      type="text"
                      className="ltr:pl-8 rtl:pr-8 search form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                      placeholder="Search for content type"
                      autoComplete="off"
                      onChange={(e) => filterSearchData(e)}
                    />
                    <Search className="inline-block size-4 absolute ltr:left-2.5 rtl:right-2.5 top-2.5 text-slate-500 dark:text-zink-200 fill-slate-100 dark:fill-zink-600" />
                  </div>

                  <div className="xl:col-span-2">
                    <Select
                      className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                      options={options}
                      isSearchable={false}
                      defaultValue={options[0]}
                      onChange={(event: any) => handleChange(event)}
                      id="choices-single-default"
                    />
                  </div>
                </div>
              </form>
            </div>
            <div className="card-body">
              {showTable ? (
                <TableContainer
                  setPagination={setPagination}
                  isPagination={true}
                  columns={mediaListColumns || []}
                  data={mediaData || []}
                  pageCount={pageCount}
                  pagination={pagination}
                  totalItems={totalItems}
                  onPaginationChange={(updater: any) => {
                    const nextState = updater(pagination);
                    if (nextState?.pageIndex !== pagination?.pageIndex)
                      setPagination(nextState);
                  }}
                  divclassName="overflow-x-auto"
                  tableclassName="w-full whitespace-nowrap"
                  theadclassName="ltr:text-left rtl:text-right bg-slate-100 text-slate-500 dark:text-zink-200 dark:bg-zink-600"
                  thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold border-y border-slate-200 dark:border-zink-500"
                  tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 border-y border-slate-200 dark:border-zink-500"
                  PaginationClassName="flex flex-col items-center mt-5 md:flex-row"
                />
              ) : (
                <>
                  <div className="grid grid-cols-2 gap-4 mt-2 mb-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 auto-rows-max">
                    {mediaData?.map((item: any) => (
                      <div
                        className="relative flex items-center justify-center w-40 h-40 p-2 border border-gray-400 rounded-md cursor-pointer"
                        key={item._id}
                        // onClick={() => {
                        //   setEventData(item);
                        //   setIsEdit(true);
                        //   setShow(true);
                        // }}
                      >
                        {item.media_type === "image" ? (
                          <img
                            src={getImageUrl(
                              `${item.media_url}${"?width=142&height=142"}`
                            )}
                            alt="img"
                            className="object-cover w-full h-full rounded"
                          />
                        ) : item.media_type === "video" ? (
                          <iframe
                            src={getImageUrl(item.media_url)}
                            className="object-contain w-full h-full rounded"
                            title="videos"
                          />
                        ) : item.media_type === "document" ? (
                          <iframe
                            src={getImageUrl(item.media_url)}
                            className="object-contain w-full h-full rounded"
                            width="165"
                            height="400"
                          />
                        ) : (
                          <audio
                            controls
                            className="object-contain w-full h-full rounded"
                          >
                            <source
                              src={getImageUrl(item.media_url)}
                              type="audio/mpeg"
                            />
                            audio
                          </audio>
                        )}
                      </div>
                    ))}
                  </div>
                  <PaginationContainer
                    setPagination={setPagination}
                    isPagination={true}
                    columns={[]}
                    data={mediaData || []}
                    pageCount={pageCount}
                    pagination={pagination}
                    totalItems={totalItems}
                    onPaginationChange={(updater: any) => {
                      const nextState = updater(pagination);
                      if (nextState?.pageIndex !== pagination?.pageIndex)
                        setPagination(nextState);
                    }}
                    divclassName="overflow-x-auto"
                    PaginationClassName="flex flex-col items-center mt-5 md:flex-row"
                  />
                </>
              )}
            </div>
          </div>
        </div>
      )}
      {/* Employee Modal */}
      <Drawer
        show={show}
        onHide={toggle}
        id="drawerEnd"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-[1050] dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">
            {!!isEdit ? "Edit Media" : "Add Media"}
          </Drawer.Title>
          <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          <form
            className="create-form"
            id="create-form"
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <input type="hidden" value="" name="id" id="id" />
            <input type="hidden" value="add" name="action" id="action" />
            <input type="hidden" id="id-field" />

            {!!isEdit ? (
              <div>
                <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
                  <div className="xl:col-span-12"></div>
                  <div className="xl:col-span-12">
                    <label
                      htmlFor="phoneNumberInput"
                      className="inline-block mb-2 text-base font-medium"
                    >
                      Tags
                    </label>
                    <Select
                      className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                      options={option}
                      isSearchable={true}
                      value={addTags}
                      isMulti={true}
                      onChange={(event: any) => handleTagChange(event)}
                      id="choices-single-default3"
                    />
                    {validation.touched.tags && validation.errors.tags ? (
                      <p className="text-red-400">{validation.errors.tags}</p>
                    ) : null}
                  </div>
                  <div className="xl:col-span-12">
                    <CustomInput
                      label="Caption"
                      name="extra_text"
                      value={eventData?.extra_text}
                      placeholder="Enter Caption"
                      onChange={(e) => {
                        console.log(e, "value");
                        setEventData((prev) => ({
                          ...prev,
                          extra_text: e.target.value,
                        }));
                      }}
                      error={null}
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
                <div className="xl:col-span-12">
                  <label
                    htmlFor="phoneNumberInput"
                    className="inline-block mb-2 text-base font-medium"
                  >
                    Media Type
                  </label>
                  <Select
                    className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                    options={options}
                    isSearchable={false}
                    defaultValue={medias ? medias : options[0]}
                    onChange={(event: any) => handleMediaChange(event)}
                    id="choices-single-default3"
                  />
                  {validation.touched.media_type &&
                  validation.errors.media_type ? (
                    <p className="text-red-400">
                      {validation.errors.media_type}
                    </p>
                  ) : null}
                </div>

                <div className="xl:col-span-12">
                  <h6 className="mb-4 text-15">Upload Media</h6>

                  {isLoading ? (
                    <div
                      className="flex justify-center"
                      style={{ marginTop: "10px" }}
                    >
                      <TailSpin
                        visible={true}
                        height="50"
                        width="50"
                        color="#4fa94d"
                      />
                    </div>
                  ) : selectedFile ? (
                    <div className="flex items-center">
                      <div className="relative w-40 h-40">
                        {selectedFile.type.split("/")[0] === "image" ? (
                          <img
                            src={selectedFile.preview}
                            alt="img"
                            className="rounded border-[gray] border"
                            style={{
                              objectFit: "contain",
                              width: "100%",
                              height: "100%",
                            }}
                          />
                        ) : selectedFile.type.split("/")[0] === "video" ? (
                          <img
                            src={video}
                            alt="Video file"
                            className="object-contain w-full h-full rounded"
                          />
                        ) : selectedFile.type.split("/")[1] === "pdf" ? (
                          <img
                            src={document_pdf}
                            alt="Document file"
                            className="object-contain w-full h-full rounded"
                          />
                        ) : (
                          <img
                            src={audio}
                            alt="Audio file"
                            className="object-contain w-full h-full rounded"
                          />
                        )}
                        <span
                          style={{
                            position: "absolute",
                            top: "0px",
                            right: "6px",
                            fontSize: "22px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setSelectedFile(null);
                          }}
                        >
                          ×
                        </span>
                      </div>
                      <div className="h-3 ml-3">
                        <input
                          type="file"
                          hidden
                          id="uploadimage49"
                          accept="image/*,video/*,audio/*,application/pdf"
                          className="hidden profile-img-file-input"
                          onChange={(e: any) =>
                            handleAcceptedFiles(e.target.files[0])
                          }
                        />
                        <label
                          htmlFor="uploadimage49"
                          className="text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                        >
                          Change
                        </label>
                      </div>
                    </div>
                  ) : (
                    <>
                      <input
                        type="file"
                        hidden
                        id="uploadimage59"
                        accept="image/*,video/*,audio/*,application/pdf"
                        className="hidden profile-img-file-input"
                        onChange={(e: any) =>
                          handleAcceptedFiles(e.target.files[0])
                        }
                      />
                      <label
                        htmlFor="uploadimage59"
                        className="text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                      >
                        {"Add Media"}
                      </label>
                    </>
                  )}
                </div>
              </div>
            )}
            <div className="flex justify-end gap-2 mt-4">
              <button
                type="reset"
                id="close-modal"
                data-modal-close="addEmployeeModal"
                className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
                onClick={toggle}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={loader}
                style={{
                  minWidth: "130px",
                  display: "flex",
                  justifyContent: "center",
                }}
                id="addNew"
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                {loader ? (
                  <span>
                    <TailSpin
                      visible={true}
                      height="20"
                      width="20"
                      color="#fff"
                    />
                  </span>
                ) : !!isEdit ? (
                  "Update "
                ) : (
                  "Add Media"
                )}
              </button>
            </div>
          </form>
        </Drawer.Body>
      </Drawer>
      <Modal
        show={showModel}
        onHide={defaultToggle}
        id="defaultModal"
        modal-center="true"
        className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
        dialogClassName="w-screen md:w-[30rem] bg-white shadow rounded-md dark:bg-zink-600 flex flex-col h-full"
      >
        <Modal.Header
          className="flex items-center justify-between p-4 border-b border-slate-200 dark:border-zink-500"
          closeButtonClass="transition-all duration-200 ease-linear text-slate-500 hover:text-red-500 dark:text-zink-200 dark:hover:text-red-500"
        >
          <Modal.Title className="text-16">{"Tags"}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
          {/* <h5 className="mb-3 text-16">{}</h5> */}
          <div className="text-slate-500 dark:text-zink-200">
            {read?.map((item) => (
              <span>
                {item}
                {","}
              </span>
            ))}
          </div>
        </Modal.Body>
      </Modal>
      {isEditFileNameEdit ? (
        <FileNameEdit
          show={isEditFileNameEdit}
          toggle={() => setIsEditFileNameEdit(!isEditFileNameEdit)}
          loader={loader}
          data={fileNameEdit}
          handleFileNameChange={handleFileNameChange}
          saveDetails={saveDetails}
        />
      ) : null}
      {isEditThumbnailEdit ? (
        <ThumbnailEdit
          show={isEditThumbnailEdit}
          toggle={() => setIsEditThumbnailEdit(!isEditThumbnailEdit)}
          loader={loader}
          data={thumbnailEdit}
          saveDetails={saveThumbnail}
          handleAcceptedFiles={handleAcceptedFilesThumbnail}
          handleMediaChange={handleMediaChange}
          isLoading={isLoading}
          selectedFile={selectedFile}
          setSelectedFile={setSelectedFile}
        />
      ) : null}
    </React.Fragment>
  );
};

export default MediaList;
